export default "__VITE_ASSET__BJXb02Ba__"